import { Box, Grid, Typography } from '@mui/material'
import styles from '../../../assets/styles/componentStyles/scheduleMeetingStyles/cardStyles.module.scss';
import React from 'react'

interface CardProps {
    children: any,
} 

const Card: React.FC<CardProps> = (props) => {
    const {children} = props;

    return (
        <Grid className={styles.cardContainer}>
            {children}
        </Grid>
    )
}

export default Card